import {type ajax} from 'jquery'
import {mthen, fromMaybe} from '@freckle/maybe'
import {leaveAjaxErrorBreadcrumb} from '@frontrow/console/src/entities/helpers/exception-handlers/bugsnag-helper'

type JQueryXHR = ReturnType<typeof ajax>

type AjaxSettings = {
  _requestStartTime: Date
  _requestOpenedTime: Date
  xhr: () => {
    readyState: number
    onreadystatechange: () => void
  }
}

export function setupAjax() {
  return $.ajaxSetup({
    dataType: 'json',
    xhrFields: {
      withCredentials: true
    },
    beforeSend: function (_jqXHR: JQueryXHR, settings: AjaxSettings) {
      //Stash the time that we queued the request
      settings._requestStartTime = new Date()
      const xhr = settings.xhr
      settings.xhr = () => {
        const output = xhr()
        output.onreadystatechange = function () {
          if (this.readyState === XMLHttpRequest.OPENED) {
            // Stash the time that the request was OPENED so that we can log how long the request
            // took on the server
            settings._requestOpenedTime = new Date()
          }
        }
        return output
      }
    },
    error(jqXHR: JQueryXHR, textStatus: string, errorThrown: string) {
      const now = +new Date()
      const totalDurationMs = now - this._requestStartTime
      const serverDurationMs = fromMaybe(
        () => 0,
        mthen(this._requestOpenedTime, t => now - t)
      )
      leaveAjaxErrorBreadcrumb({
        reqType: this.type,
        reqUrl: this.url,
        reqStatus: {status: jqXHR.status.toString(), textStatus},
        totalDurationMs,
        serverDurationMs,
        errorThrown
      })
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } as any)
}
